import { useEffect, useState } from "react";
import Hamburger from "../../../common/Hamburger";
import useWindowSize from "../../../hooks/useWindowSize";
import LanguageSelect from "./components/LanguageSelect";
import NavBar from "./components/NavBar";
import Sidebar from "./components/Sidebar";
import Welcome from "./components/Welcome";
import styles from "./styles.module.css";

const Header = () => {
  const size = useWindowSize();
  const [isSmallWindow, setIsSmallWindow] = useState(size?.width < 1000);
  const [isShowSidebar, setIsShowSidebar] = useState(false);

  const toggleSidebar = () => setIsShowSidebar((prev) => !prev);

  useEffect(() => {
    const isSmall = size?.width < 1000;
    setIsSmallWindow(isSmall);
    if (!isSmall) setIsShowSidebar(false);
  }, [size?.width]);

  return (
    <>
      <div
        className={`${styles.root} ${
          isSmallWindow ? styles.smallRoot : styles.bigRoot
        }`}
      >
        {isSmallWindow && (
          <button onClick={toggleSidebar}>
            <Hamburger />
          </button>
        )}
        {isShowSidebar && <Sidebar toggle={toggleSidebar} />}
        <div className={styles.wrapper}>
          <LanguageSelect className={styles.language} />
          <div className={styles.welcomeWrapper}>
            <Welcome isSmallWindow={isSmallWindow} />
          </div>
        </div>
      </div>
      {!isSmallWindow && <NavBar />}
    </>
  );
};

export default Header;
